import { Component, OnInit } from '@angular/core';
import { NavParams, ModalController } from '@ionic/angular';
import { SearchService } from '../../services/search.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-seguidores',
  templateUrl: './seguidores.component.html',
  styleUrls: ['./seguidores.component.scss'],
})
export class SeguidoresComponent implements OnInit {

  follower:any = [];
  
  private id:number;
  private auth_key:string;
  displayUserData:any;

  constructor(
    private navParams: NavParams,
    private searchService: SearchService,
    private authService: AuthService,
    private modalCtrl: ModalController
  ) {
    if(navParams.get('show')){
      
    }
   }

  ngOnInit() {
    this.authService.userData$.subscribe((res: any) => {
      if(!this.displayUserData){        
        this.displayUserData =  res;
        this.loadVariables();
      }
    });
  }

  loadVariables(){
    this.id = this.displayUserData?.id;
    this.auth_key = this.displayUserData?.auth_key;
    this.getFollower();
  }

  getFollower(){
    this.searchService.getFollower(this.id,this.auth_key).subscribe((res)=>{
      this.follower = res;
    });
  }

  close(){
    this.modalCtrl.dismiss();
  }

}
